module.exports = __webpack_public_path__ + "img/nat.43ac4e00.png";